import { string } from 'yup';
const history = {};
const debounce = (callback, timeout) => {
    let lastChecked = null;
    return (...args) => {
        lastChecked = new Date().getTime();
        setTimeout(() => {
            if (lastChecked && new Date().getTime() - lastChecked >= timeout) {
                callback(...args);
                lastChecked = null;
            }
        }, timeout);
    };
};
export const validationFunction = async (value, resolve) => {
    var _a, _b;
    try {
        const domain = value.split('@')[1];
        const response = await fetch(`https://dns.google.com/resolve?name=${domain}&type=mx`);
        const json = await response.json();
        history[domain] = ((_a = json.Answer) === null || _a === void 0 ? void 0 : _a.length) || false;
        resolve((_b = json.Answer) === null || _b === void 0 ? void 0 : _b.length);
    }
    catch (error) {
        // if the DNS service is unavailable we assume valid email domain
        resolve(true);
    }
};
const validationDebounced = debounce(validationFunction, 400);
const emailValidator = string().test('isValidEmailDomain', 'Invalid domain (check the part after "@")', (value) => {
    const domain = value.split('@')[1];
    return new Promise((resolve) => {
        if (history[domain] !== undefined) {
            resolve(history[domain]);
        }
        else {
            validationDebounced(value, resolve);
        }
    });
});
export default emailValidator;
//# sourceMappingURL=index.js.map